export default __webpack_public_path__ + "static/media/673.1d3fc77b.png";